const grillaBusquedaState = {
  modalEditarPrestacion: false,
  modalEliminarPrestacion: false,
  idPrestacionEditar: 0,
  idPrestacionEliminar: 0,
  prestacionesPP: [],
};

export default grillaBusquedaState;




// WEBPACK FOOTER //
// ./src/components/ActualizarArancel/GrillaBusqueda/state.js